export const words = {
  place: "Posizione",
  yes: "Sì",
  no: "No",
  new: "Nuovo",
  agb: 'AGB',
  agb_full: "Termini e condizioni generali",
  datenschutzerklaerung: "Informativa sulla privacy",
  status: "Stato",
  company_name: "Nome della società",
  next_button: "Ulteriori",
  device_name: "Nome del dispositivo",
  to_connect: "Collegare",
  pin: 'PIN',
  time: "Tempo",
  first_name: "Nome",
  last_name: "Cognome",
  code: "Codice",
  help: "Aiuto",
  total_time: "Tempo totale",
  latitude: "Latitudine",
  longitude: "Longitudine",
  accuracy: "Precisione",
  timestamp: "Timestamp",
  device_id: "ID dispositivo",
  active: "attivo",
  o_clock: "Orologio",
  loading: "Negozio",
  annotation: "Nota",
  since: "da",
  camera: "Macchina fotografica",
  map: "Mappa",
  gallery: "Galleria",
  work: "Lavoro",
  employees: "I dipendenti",
  login: "Registrazione",
  login_action: "Accedi",
  calendar_week_abbreviation: 'KW',
  calendar: "Calendario",
  to_call: "Chiamata",
  email: "E-mail",
  attachment: "Appendice",
  operational_planning: "Piano operativo",
  to_scan: "Scansione",
  download: "Scaricare",
  export: "Esportazione",
  to_document: "Documento",
  checklist: "Lista di controllo",
  checklists: "Liste di controllo",
  password: "Password",
  confirmation: "Conferma",
  confirm: "Confermare",
  confirmation_email: "E-mail di conferma",
  unknown: "Sconosciuto",
  unknown_place: "Posizione sconosciuta",
  unknown_plan: "Orario dei turni non specificato",
  project_no: "Progetto n.",
  project_file: "File di progetto",
  contact_person: "Contatto",
  overtime: "Lavoro straordinario",
  timesheet: "Orario",
  minustime: "Meno ore",
  back: "Indietro",
  undo: "Annullamento",
  clockout: "Timbrare",
  clocked_out: "timbrato",
  clockin: "Timbro in",
  clocked_in: "timbrato",
  dismiss: "Annullamento",
  discard: "Rigettare",
  finish: "Pronto",
  or: "o",
  copy: "Copiare",
  qr_code: "Codice QR",
  documentation: "Registrazione dei tempi e documentazione",
  attendance: "Terminale per tablet",
  tiercontent: "Portata del pacchetto",
  start_now: "Inizia subito",
  skip: "saltare",
  logout_during_core_time: "Timbrato durante l'orario centrale",
  absent_during_core_time: "Assente durante il core time",
  distance: "Distanza",
  km_reading: "Chilometraggio",
  the_start: "Inizio",
  the_end: "Fine",
  license_plate: "Targa",
  details: "dettagli",
  hide: "nascondersi",
  cost: "Costi",
  file: "File",
  address_book: "Rubrica",
  template_plural: "Modelli",
  signature: "Firma",
  main_project: "Progetto principale",
  main_projects: "Progetti principali",
  sub_projects: "Sottoprogetti",
  scan_to_login_header: "Registrazione con codice QR",
  description: "Descrizione",
  project_location: "Posizione del progetto",
  phone_number: "Numero di telefono",
  project_info: "Informazioni sul progetto",
  number_short: "No.",
  sketch: "Schizzo",
  video: 'Video',
  delete: "Cancellare",
  send: "Inviare",
  sending: "Invia...",
  save: "Risparmiare",
  granted: "approvato",
  pending: "richiesto",
  denied: "Rifiutato",
  customer: "Cliente",
  mobile_number: "Numero di telefono",
  ok: 'Ok',
  day: "Giorno",
  tomorrow: "Mattina",
  days: "Giorni | Giorno | Giorni",
  holidays: "Vacanze",
  vacation_days: "Vacanze",
  vacation_hours: "Orari di vacanza",
  request: "Richiesta",
  accept: "Accettare",
  withdraw: "Ritirare",
  hour_account: "Conto orario",
  period: "Periodo",
  to: "a",
  date: "Appuntamento",
  number: "Numero",
  message: "Messaggio",
  change: "cambiamento",
  changed: "Cambiato",
  changed_fields: "Cambio di campo",
  type: "Arte",
  hour: "Ora",
  hours: "Ore",
  hours_abbreviation: "Standard.",
  hours_with_amount: "{amount} Orario",
  end: "fine",
  end_date: "Scadenza",
  start_date: "Data di inizio",
  absence: "Assenza",
  month: "mese",
  week: "Settimana",
  transcript: "Trascrizione",
  time_left: "rimanente",
  transcript_tasks: "Attività",
  add_task: "Nuovo",
  /** Differentiation in some languages (e.g. English) */
  from: "da",
  of: "da",
  of_hours: "da {hours} ore",
  of_hours_abbreviation: "{hours} dalle ore.",
  /**************/

  used: "usato",
  update: "Aggiornamento",
  today: "oggi",
  correction: "Correzione",
  work_time: "Tempo di lavoro",
  break: "Pausa",
  loading_time: "Tempo di caricamento",
  driving_time: "Tempo di viaggio",
  business_trip: "Tour di servizio",
  project: "Progetto",
  special_one: "Speciale1",
  special_two: "Speciale2",
  clock: "Orologio",
  search: "Ricerca",
  operation: "Attività",
  day_protocol: "Protocollo giornaliero",
  continue: "di più",
  total_duration: "Tempo totale",
  duration: "Durata",
  hello: "Ciao",
  close: "chiudere",
  comment: "Commento",
  small: "piccolo",
  medium: "medio",
  large: "grande",
  sharpie: "Spillo",
  line: "Linea",
  arrow: "Freccia",
  rectangle: "Rettangolo",
  ellipse: "Ellisse",
  text: "Testo",
  language_settings: "Impostazioni della lingua",
  clock_reminder: "Promemoria per il francobollo",
  individually: "Individuo",
  from_o_clock: "da",
  to_o_clock: "a",
  eraser: "Gomma",
  edit: "Modifica",
  legal_notes: "Legale",
  notes: "Note",
  note: "Nota",
  imprint: "Impronta",
  open_source_licenses: "Termini della licenza open source",
  author: "Autore",
  license_type: "Tipo di licenza",
  version: "Versione",
  substitute: "Rappresentazione",
  not_rated: "Non valutato",
  weekly_working_hours: "Orario di lavoro settimanale",
  show_less: "Mostra meno",
  office_center: "Centro uffici",
  admin_view: "Gestione NFC",
  register: "Registrati",
  shifts: {
    shift_attachments: "Accessori (strato)",
    shift_plan_attachments: "Accessori (piano dei turni)",
    shift_plan: "Turni",
    shift: "Strato"
  },
  absences: {
    sick: "Malattia (continuazione del pagamento del salario)",
    vacation: "Vacanze",
    workshop: "Seminario/Corso",
    special_vacation: "Congedo speciale",
    school: "Scuola",
    working_time_account: "Conto dell'orario di lavoro",
    holiday: "Vacanze",
    other: "Altro",
    driving_time: "Tempo di viaggio",
    parental_leave: "Congedo parentale",
    excused_absent: "Assente giustificato (pagato)",
    not_excused_absent: "Assenza senza giustificazione",
    sick_industrial_accident: "Malattia Infortunio sul lavoro (LFZ)",
    short_time_work: "Lavoro a tempo ridotto (Kug)",
    maternity_pay: "Protezione della maternità divieto di retribuzione/occupazione",
    sick_child: "Cura di un bambino malato con retribuzione di malattia (giornaliera)",
    sick_child_no_payment: "Assistenza a un bambino malato senza retribuzione di malattia (giornaliera)",
    vacation_no_payment: "Congedo non retribuito",
    sick_before_short_time_work: "Indennità di malattia/malattia prima del Kug",
    weather_related_failure: "Guasto dovuto alle condizioni meteorologiche",
    sick_short_time_work: "Malattia durante il Kug",
    sick_no_payment: "Malattia (senza continuazione della retribuzione)",
    company_vacation: "Vacanze aziendali",
    meals_14_euro: "Piccola indennità di ristorazione",
    meals_28_euro: "Ampia indennità di ristorazione"
  },
  image_editor: {
    font_size: "Dimensione del carattere",
    stroke_width: "Larghezza della linea",
    stroke_color: "Colore della linea",
    text_color: "Colore del carattere",
    rotate_left: "Girare a sinistra",
    rotate_right: "Girare a destra",
    flip_horizontal: "Specchio in orizzontale",
    flip_vertical: "Specchio verticale"
  },
  travel_log: {
    method_of_transportation: "Mezzi di trasporto",
    company_car: "Auto aziendale",
    private_car: "Auto privata",
    rental_car: "Auto a noleggio",
    taxi: 'Taxi',
    public_transportation: "Trasporto pubblico",
    airplane: "Velivolo",
    train: "Ferrovia (trasporto pubblico a lunga distanza)",
    other: "Altro",
    km_reading_start: "Inizio chilometraggio",
    km_reading_end: "Fine del chilometraggio",
    net_expenses: "Spese di viaggio (nette)",
    tax: "Imposta sul valore aggiunto"
  },
  read_in: "Leggi in",
  currency: "Valuta",
  reason: "Motivo",
  label: "Etichetta",
  monday: "Lunedì",
  tuesday: "Martedì",
  wednesday: "Mercoledì",
  thursday: "Giovedì",
  friday: "Venerdì",
  saturday: "Sabato",
  sunday: "Domenica",
  break_alarm: "Rompere la sveglia",
  clockin_reminder: "Promemoria per timbrare il cartellino",
  clockout_reminder: "Promemoria per disiscriversi"
};